import React, { useState } from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "../../../context/FavoriteContext/FavoriteContext";
import { useCustomerAuth } from "../../../context/CustomerAuthContext/CustomerAuthContext";
import { useNavigate } from "react-router-dom";

type Props = {
  urunId: number;
  size?: number;
  className?: string;
};

const FavoriteButton: React.FC<Props> = ({ urunId, size = 18, className = "" }) => {
  const { isFavorite, toggle } = useFavorites();
  const { token } = useCustomerAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const fav = isFavorite(urunId);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!token) {
      navigate("/musteri/giris");
      return;
    }
    if (busy) return;
    setBusy(true);
    try {
      await toggle(urunId);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={busy}
      title={fav ? "Favorilerden kaldır" : "Favorilere ekle"}
      aria-label={fav ? "Favorilerden kaldır" : "Favorilere ekle"}
      className={[
        "flex items-center justify-center rounded-full transition-all duration-200",
        "w-8 h-8 bg-white/90 backdrop-blur shadow-sm border border-white/60",
        busy ? "opacity-50 scale-90" : "hover:scale-110 hover:shadow-md",
        className,
      ].join(" ")}
    >
      <Heart
        size={size}
        className={
          fav
            ? "fill-red-500 text-red-500 transition-colors"
            : "text-slate-400 transition-colors group-hover:text-red-400"
        }
      />
    </button>
  );
};

export default FavoriteButton;
